import React,{ useState, useEffect } from "react"
import axios from "axios"
import jwt_decode from "jwt-decode"
import { useParams ,useNavigate } from "react-router-dom"
import baseURL from "../../Url/Url.jsx"
import SideBar from "../../Layout/SideBar.jsx"

const MenuUbahKaryawanTidakTetap = () => {
    // variabel sistem utama
    // Data karyawan
    const [id, setId] = useState("")
    const [nama, setNama] = useState("")
    const [nik, setNik] = useState("")
    const [ktp, setKtp] = useState("")
    const [npwp, setNpwp] = useState("")
    const [jenisKelamin, setJenisKelamin] = useState("")
    const [statusKawin, setStatusKawin] = useState("")
    const [unitKerja, setUnitKerja] = useState("")
    const [jabatan, setJabatan] = useState("")
    const [divisi, setDivisi] = useState("")
    const [stat, setStat] = useState("")
    const [golongan, setGolongan] = useState("")
    const [alamat, setAlamat] = useState("")
    const [nomorRekening, setNomorRekening] = useState("")
    const [namaBank, setNamaBank] = useState("")
    const [tanggalLahir, setTanggalLahir] = useState("")
    const [tanggalMasuk, setTanggalMasuk] = useState("")
    const [tanggalKeluar, setTanggalKeluar] = useState("")
    // Data gaji penghasilan
    const [gajiPokok, setGajiPokok] = useState(0)
    const [tBKesehatan, setTBKesehatan] = useState(0)
    const [tBJmk, setTBJmk] = useState(0)
    const [tBJkk, setTBJkk] = useState(0)
    const [tBJht, setTBJht] = useState(0)
    const [tBPensiun, setTBPensiun] = useState(0)
    const [tPremiHRV, setTPremiHRV] = useState(0)
    const [tPremiNonHRV, setTPremiNonHRV] = useState(0)
    const [tPremiJabatan, setTPremiJabatan] = useState(0)
    const [tPremiBorongan, setTPremiBorongan] = useState(0)
    const [tPremiKontan, setTPremiKontan] = useState(0)
    const [tPremiLainnya, setTPremiLainnya] = useState(0)
    const [tCatuBeras, setTCatuBeras] = useState(0)
    const [thr, setThr] = useState(0)
    const [bonus, setBonus] = useState(0)
    const [lembur, setLembur] = useState(0)
    const [tPph, setTPph] = useState(0)
    const [rapelGaji, setRapelGaji] = useState(0)
    const [lainnya, setLainnya] = useState(0)
    // Data gaji potongan
    const [iBKesehatan, setIBKesehatan] = useState(0)
    const [iBPensiun, setIBPensiun] = useState(0)
    const [iBJht, setIBJht] = useState(0)
    const [pBkesehatan, setPBkesehatan] = useState(0)
    const [pBPensiun, setPBPensiun] = useState(0)
    const [pBJkm, setPBJkm] = useState(0)
    const [pBJkk, setPBJkk] = useState(0)
    const [pBJht, setPBJht] = useState(0)
    const [pKontanan, setPKontanan] = useState(0)
    const [pTotal, setPTotal] = useState(0)
    const [pLainnya, setPLainnya] = useState(0)
    const [perusahaan, setPerusahaan] = useState("")
    const [bulan, setBulan] = useState("")
    const [tahun, setTahun] = useState("")
    const [displayLoader, setDisplayLoader] = useState("none")
    const [, setToken] = useState("")
    const [expire, setExpire] = useState("")
    const navigate = useNavigate()
    const [ktpError, setKtpError] = useState("")
    const [npwpError, setNpwpError] = useState("")
    const [tanggalLahirView, setTanggalLahirView] = useState("")
    const [tanggalMasukView, setTanggalMasukView] = useState("")
    const [tanggalKeluarView, setTanggalKeluarView] = useState("")
    const { idParams } = useParams()

    // Sistem utama
    useEffect(()=>{
        refreshToken()
        selectKaryawanTidakTetap()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Refresh token
    const refreshToken = async() => {
        try {
            const response = await axios.get(`${baseURL}/tokenBE`)
            setToken(response.data.accessToken)
            const decoded = jwt_decode(response.data.accessToken)
            setPerusahaan(decoded.perusahaan)
            setBulan(decoded.bulan)
            setTahun(decoded.tahun)
            setExpire(decoded.exp)
        } catch (error) {
            if(error.response){
                navigate("/", { replace: true })
            }   
        }
    }

    const axiosJWT = axios.create()
    axiosJWT.interceptors.request.use(async(config) => {
        const currentDate = new Date()
        if(expire * 1000 < currentDate.getTime()){
            const response = await axios.get("/tokenBE")
            config.headers.Authorization = `Bearer ${response.data.accessToken}`
            setToken(response.data.accessToken)
            const decoded = jwt_decode(response.data.accessToken)
            setPerusahaan(decoded.perusahaan)
            setBulan(decoded.bulan)
            setTahun(decoded.tahun)
            setExpire(decoded.exp)
        }
        return config
    }, (error)=>{
        return Promise.reject(error)
    })

    // Logout
    const Logout = async() =>{
        try {
            await axios.delete(`${baseURL}/logoutBE`)
            navigate("/", { replace: true })
        } catch (error) {
            console.log(error)
        }
    }

    // Format tanggal
    const formatTanggalIndonesia = (value) => {
        if (!value) return ""
    
        const bulan = [
        "Januari", "Februari", "Maret", "April", "Mei", "Juni",
        "Juli", "Agustus", "September", "Oktober", "November", "Desember"
        ]
    
        const date = new Date(value)
        if (isNaN(date)) return ""
    
        return `${date.getDate()} ${bulan[date.getMonth()]} ${date.getFullYear()}`
    }      

    // Ubah karyawan tidak tetap
    const updateKaryawanTidakTetap = async (e) => {
        e.preventDefault()
        try {
            setDisplayLoader("")
            await axios.patch(`${baseURL}/updateKaryawanTidakTetapBE/`,{
                id: id,
                nama: nama,
                nik: nik,
                ktp: ktp,
                npwp: npwp,
                jenisKelamin: jenisKelamin,
                statusKawin: statusKawin,
                unitKerja: unitKerja,
                jabatan: jabatan,
                divisi: divisi,
                stat: stat,
                golongan: golongan,
                alamat: alamat,
                nomorRekening: nomorRekening,
                namaBank: namaBank,
                tanggalLahir: tanggalLahir,
                tanggalMasuk: tanggalMasuk,
                tanggalKeluar: tanggalKeluar,
                gajiPokok: gajiPokok,
                tBKesehatan: tBKesehatan,
                tBJmk: tBJmk,
                tBJkk: tBJkk,
                tBJht: tBJht,
                tBPensiun: tBPensiun,
                tPremiHRV: tPremiHRV,
                tPremiNonHRV: tPremiNonHRV,
                tPremiJabatan: tPremiJabatan,
                tPremiBorongan: tPremiBorongan,
                tPremiKontan: tPremiKontan,
                tPremiLainnya: tPremiLainnya,
                tCatuBeras: tCatuBeras,
                thr: thr,
                bonus: bonus,
                lembur: lembur,
                tPph: tPph,
                rapelGaji: rapelGaji,
                lainnya: lainnya,
                iBKesehatan: iBKesehatan,
                iBPensiun: iBPensiun,
                iBJht: iBJht,
                pBkesehatan: pBkesehatan,
                pBPensiun: pBPensiun,
                pBJkm: pBJkm,
                pBJkk: pBJkk,
                pBJht: pBJht,
                pKontanan: pKontanan,
                pTotal: pTotal,
                pLainnya: pLainnya,
                perusahaan: perusahaan,
                bulan: bulan,
                tahun: tahun,
            })
            navigate(`/menu-karyawan-tidak-tetap/${perusahaan}/${bulan}/${tahun}`, { replace: true })
            window.location.reload()
        } catch (error) {
            if(error.response){
                setDisplayLoader("none")
                console.log(error.response.data.msg)
            }
        }
    }

    // Mengambil karyawan tidak tetap
    const selectKaryawanTidakTetap = async() =>{
        try{
            const response = await axios.get(`${baseURL}/selectKaryawanTidakTetapByKtpBE/${idParams}`)
            setId(response.data.id)
            setNama(response.data.nama)
            setNik(response.data.nik)
            setKtp(response.data.ktp)
            setNpwp(response.data.npwp)
            setJenisKelamin(response.data.jenisKelamin)
            setStatusKawin(response.data.statusKawin)
            setUnitKerja(response.data.unitKerja)
            setJabatan(response.data.jabatan)
            setDivisi(response.data.divisi)
            setStat(response.data.stat)
            setGolongan(response.data.golongan)
            setAlamat(response.data.alamat)
            setNomorRekening(response.data.nomorRekening)
            setNamaBank(response.data.namaBank)
            setTanggalLahir(response.data.tanggalLahir)
            setTanggalMasuk(response.data.tanggalMasuk)
            setTanggalKeluar(response.data.tanggalKeluar)
            setGajiPokok(response.data.gajiPokok)
            setTBKesehatan(response.data.tBKesehatan)
            setTBJmk(response.data.tBJmk)
            setTBJkk(response.data.tBJkk)
            setTBJht(response.data.tBJht)
            setTBPensiun(response.data.tBPensiun)
            setTPremiHRV(response.data.tPremiHRV)
            setTPremiNonHRV(response.data.tPremiNonHRV)
            setTPremiJabatan(response.data.tPremiJabatan)
            setTPremiBorongan(response.data.tPremiBorongan)
            setTPremiKontan(response.data.tPremiKontan)
            setTPremiLainnya(response.data.tPremiLainnya)
            setTCatuBeras(response.data.tCatuBeras)
            setThr(response.data.thr)
            setBonus(response.data.bonus)
            setLembur(response.data.lembur)
            setTPph(response.data.tPph)
            setRapelGaji(response.data.rapelGaji)
            setLainnya(response.data.lainnya)
            setIBKesehatan(response.data.iBKesehatan)
            setIBPensiun(response.data.iBPensiun)
            setIBJht(response.data.iBJht)
            setPBkesehatan(response.data.pBkesehatan)
            setPBPensiun(response.data.pBPensiun)
            setPBJkm(response.data.pBJkm)
            setPBJkk(response.data.pBJkk)
            setPBJht(response.data.pBJht)
            setPKontanan(response.data.pKontanan)
            setPTotal(response.data.pTotal)
            setPLainnya(response.data.pLainnya)
        }catch(error){
            console.log(error)
        }
    }

    // Format NPWP
    const formatNPWP = (value) => {
        const parts = [
          value.slice(0, 2),
          value.slice(2, 5),
          value.slice(5, 8),
          value.slice(8, 9),
          value.slice(9, 12),
          value.slice(12, 15),
        ];
      
        let result = "";
        if (parts[0]) result += parts[0];
        if (parts[1]) result += "." + parts[1];
        if (parts[2]) result += "." + parts[2];
        if (parts[3]) result += "." + parts[3];
        if (parts[4]) result += "-" + parts[4];
        if (parts[5]) result += "." + parts[5];
      
        return result;
    };

    // Halaman
    return (
        <div id="wrapper">

            {/* LOADER */}
            <div className="loader-page-bg" style={{display:displayLoader}}>
                <div className="loader-page"></div>
            </div>

             {/* SIDE BAR */}
             <SideBar 
                bulanParams={bulan}
                tahunParams={tahun}
                perusahaanParams={perusahaan}
                tahunSekarang={tahun}
            />

            {/* KONTEN WRAP */}
            <div id="content-wrapper">
                
                {/* NAVBAR */}
                <nav className="navbar navbar-expand-sm sticky-top nav-bar py-3">
                    <div className="container">
                        <div className="dropdown ml-2">
                            <button className="navbar-toggler mb-2" data-bs-toggle="collapse" data-bs-target="#sidebar" aria-controls="sidebar" aria-expanded="false" aria-label="Toggle navigation" style={{border:"none"}}>
                                <i className="bi bi-grid-fill" style={{fontSize:"22px"}}></i>
                            </button>
                        </div>
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0"></ul>
                        <div className="d-flex" role="search">
                            <input type="text" className="form-control form" value={perusahaan} style={{marginTop:"-2px",color:"rgb(108, 108, 108)",fontWeight:"700",maxWidth:"300px"}} readOnly/>
                            <input type="text" className="form-control form mx-2" value={bulan} style={{marginTop:"-2px",color:"rgb(108, 108, 108)",fontWeight:"700",maxWidth:"120px",textAlign:"center"}} readOnly/>
                            <input type="text" className="form-control form" value={tahun} style={{marginTop:"-2px",color:"rgb(108, 108, 108)",fontWeight:"700",maxWidth:"70px",textAlign:"center"}} readOnly/>
                            <button onClick={Logout} className="btn btn-logout mx-2"><i className="bi bi-power" style={{color:"white",fontSize:"22px"}}></i></button>
                        </div>
                    </div>
                </nav>
                {/* KONTEN */}
                <div className="container-fluid" style={{overflow:"auto",display:"block",width:"100%",height:"88vh"}}>
                    <h4 className="text-center mt-4" style={{fontWeight:"700"}}>Menu Ubah Karyawan Tidak Tetap</h4>
                    <div className="row">
                        <div className="col-12">
                            <div className="box p-4" style={{width: "100%"}}>
                                <div className="row justify-content-center">
                                    <div className="col-12 mb-4">
                                        <div className="row">
                                            <form onSubmit={updateKaryawanTidakTetap}>
                                                <p className="text-center mt-1 fw-bold">-- Data Karyawan --</p>
                                                <div className="row px-4 pt-3" style={{backgroundColor:"rgb(255, 252, 252)",borderRadius:"10px"}}>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="nama">Nama</label>
                                                        <input type="text" maxLength={200} id="nama" className="form form-control" value={nama} onChange={(e)=>setNama(e.target.value)} style={{fontSize:"11pt"}} required/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="nik">NIK</label>
                                                        <input type="text" maxLength={50} id="nik" className="form form-control" value={nik} onChange={(e)=>setNik(e.target.value)} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="ktp">KTP</label>
                                                        <input type="text" id="ktp" className="form form-control" value={ktp} onChange={(e)=>{const input = e.target.value;if (/^\d{0,16}$/.test(input)) {setKtp(input);setKtpError("")} else {setKtpError("Masukan angka");setTimeout(() => {setKtpError("")}, 3000)}}} style={{fontSize:"11pt"}} required/>
                                                        {ktpError && (
                                                        <div className="invalid-feedback d-block" style={{ fontSize: "10pt" }}>
                                                            {ktpError}
                                                        </div>
                                                        )}
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="npwp">NPWP</label>
                                                        <input type="text" id="npwp" className="form form-control" value={npwp} onChange={(e)=>{const input = e.target.value;if (/^\d{0,16}$/.test(input)) {setNpwp(input);setNpwpError("")} else {setNpwpError("Masukan angka");setTimeout(() => {setNpwpError("")}, 3000)}}} style={{fontSize:"11pt"}}/>
                                                        {npwpError && (
                                                        <div className="invalid-feedback d-block" style={{ fontSize: "10pt" }}>
                                                            {npwpError}
                                                        </div>
                                                        )}
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="jenisKelamin">Jenis Kelamin</label>
                                                        <select className="form-select form text-center" id="jenisKelamin" aria-label="jenisKelamin" value={jenisKelamin} onChange={(e)=>setJenisKelamin(e.target.value)} required>
                                                            <option defaultValue="Laki-laki">-- Pilih --</option>
                                                            <option defaultValue="Laki-laki">Laki-laki</option>
                                                            <option defaultValue="Perempuan">Perempuan</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="statusKawin">Status Kawin</label>
                                                        <select className="form-select form text-center" id="statusKawin" aria-label="statusKawin" value={statusKawin} onChange={(e)=>setStatusKawin(e.target.value)} required>
                                                        <option defaultValue="TK">-- Pilih --</option>
                                                        <option defaultValue="TK">TK</option>
                                                        <option defaultValue="TK/1">TK/1</option>
                                                        <option defaultValue="TK/2">TK/2</option>
                                                        <option defaultValue="TK/3">TK/3</option>
                                                        <option defaultValue="K/0">K/0</option>
                                                        <option defaultValue="K/1">K/1</option>
                                                        <option defaultValue="K/2">K/2</option>
                                                        <option defaultValue="K/3">K/3</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="unitKerja">Unit Kerja</label>
                                                        <input type="text" maxLength={100} id="unitKerja" className="form form-control" value={unitKerja} onChange={(e)=>setUnitKerja(e.target.value)} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="jabatan">Jabatan</label>
                                                        <input type="text" maxLength={100} id="jabatan" className="form form-control" value={jabatan} onChange={(e)=>setJabatan(e.target.value)} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-md-2 mb-3">
                                                        <label htmlFor="divisi">Divisi</label>
                                                        <input type="text" maxLength={100} id="divisi" className="form form-control" value={divisi} onChange={(e)=>setDivisi(e.target.value)} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-md-2 mb-3">
                                                        <label htmlFor="stat">Stat</label>
                                                        <input type="text" maxLength={100} id="stat" className="form form-control" value={stat} onChange={(e)=>setStat(e.target.value)} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="golongan">Golongan</label>
                                                        <input type="text" maxLength={100} id="golongan" className="form form-control" value={golongan} onChange={(e)=>setGolongan(e.target.value)} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="alamat">Alamat</label>
                                                        <input type="text" maxLength={700} id="alamat" className="form form-control" value={alamat} onChange={(e)=>setAlamat(e.target.value)} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="nomorRekening">Nomor Rekening</label>
                                                        <input type="text" id="nomorRekening" className="form form-control" value={nomorRekening} onChange={(e)=>{const input = e.target.value;if (/^\d{0,35}$/.test(input)) {setNomorRekening(input);}}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="namaBank">Nama Bank</label>
                                                        <input type="text" maxLength={100} id="namaBank" className="form form-control" value={namaBank} onChange={(e)=>setNamaBank(e.target.value)} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-md-2 mb-3">
                                                        <label htmlFor="tanggalLahir">Tanggal Lahir</label>
                                                        {/* DATE PICKER (hidden) */}
                                                        <input type="date"id="tanggalLahirPicker"className="d-none"value={tanggalLahir}onChange={(e) => {
                                                            setTanggalLahir(e.target.value)
                                                            setTanggalLahirView(formatTanggalIndonesia(e.target.value))}}
                                                        />
                                                        {/* DISPLAY */}
                                                        <input type="text"className="form form-control"placeholder="12 Januari 2026"value={tanggalLahirView}readOnly onClick={() => document.getElementById("tanggalLahirPicker").showPicker()}style={{ fontSize: "11pt", cursor: "pointer" }}/>
                                                    </div>
                                                    <div className="col-12 col-md-2 mb-3">
                                                        <label htmlFor="tanggalMasuk">Tanggal Masuk</label>
                                                        {/* DATE PICKER (hidden) */}
                                                        <input type="date" id="tanggalMasukPicker"className="d-none"value={tanggalMasuk}
                                                            onChange={(e) => {
                                                            setTanggalMasuk(e.target.value)
                                                            setTanggalMasukView(formatTanggalIndonesia(e.target.value))
                                                            }}
                                                        />
                                                        {/* DISPLAY */}
                                                        <input type="text"className="form form-control"placeholder="12 Januari 2026"value={tanggalMasukView} readOnly onClick={() =>document.getElementById("tanggalMasukPicker").showPicker()}style={{ fontSize: "11pt", cursor: "pointer" }}/>
                                                    </div>
                                                    <div className="col-12 col-md-2 mb-3">
                                                        <label htmlFor="tanggalKeluar">Tanggal Keluar</label>
                                                        {/* DATE PICKER (hidden) */}
                                                        <input type="date"id="tanggalKeluarPicker"className="d-none"value={tanggalKeluar}
                                                            onChange={(e) => {
                                                            setTanggalKeluar(e.target.value)
                                                            setTanggalKeluarView(formatTanggalIndonesia(e.target.value))
                                                            }}
                                                        />
                                                        {/* DISPLAY */}
                                                        <input type="text"className="form form-control"placeholder="12 Januari 2026"value={tanggalKeluarView}readOnly onClick={() =>document.getElementById("tanggalKeluarPicker").showPicker()}style={{ fontSize: "11pt", cursor: "pointer" }}/>
                                                    </div>
                                                </div>
                                                <p className="text-center mt-3 fw-bold">-- Data Gaji Penghasilan --</p>
                                                <div className="row px-4 pt-3" style={{backgroundColor:" rgb(252, 255, 252)",borderRadius:"10px"}}>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="gajiPokok">Gaji Pokok</label>
                                                        <input type="text" id="gajiPokok" className="form form-control" value={gajiPokok} onFocus={() => {if (gajiPokok === 0) {setGajiPokok(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setGajiPokok(input); }}onBlur={() => {if (gajiPokok === "") {setGajiPokok(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="tBKesehatan">T. BPJS Kesehatan</label>
                                                        <input type="text" id="tBKesehatan" className="form form-control" value={tBKesehatan} onFocus={() => {if (tBKesehatan === 0) {setTBKesehatan(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setTBKesehatan(input); }}onBlur={() => {if (tBKesehatan === "") {setTBKesehatan(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="tBJmk">T. BPJS JMK</label>
                                                        <input type="text" id="tBJmk" className="form form-control" value={tBJmk} onFocus={() => {if (tBJmk === 0) {setTBJmk(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setTBJmk(input); }}onBlur={() => {if (tBJmk === "") {setTBJmk(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="tBJkk">T. BPJS JKK</label>
                                                        <input type="text" id="tBJkk" className="form form-control" value={tBJkk} onFocus={() => {if (tBJkk === 0) {setTBJkk(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setTBJkk(input); }}onBlur={() => {if (tBJkk === "") {setTBJkk(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="tBJht">T. BPJS JHT</label>
                                                        <input type="text" id="tBJht" className="form form-control" value={tBJht} onFocus={() => {if (tBJht === 0) {setTBJht(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setTBJht(input); }}onBlur={() => {if (tBJht === "") {setTBJht(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="tBPensiun">T. BPJS Pensiun</label>
                                                        <input type="text" id="tBPensiun" className="form form-control" value={tBPensiun} onFocus={() => {if (tBPensiun === 0) {setTBPensiun(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setTBPensiun(input); }}onBlur={() => {if (tBPensiun === "") {setTBPensiun(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-md-2 mb-3">
                                                        <label htmlFor="tPremiHRV">T. Premi HRV</label>
                                                        <input type="text" id="tPremiHRV" className="form form-control" value={tPremiHRV} onFocus={() => {if (tPremiHRV === 0) {setTPremiHRV(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setTPremiHRV(input); }}onBlur={() => {if (tPremiHRV === "") {setTPremiHRV(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-md-2 mb-3">
                                                        <label htmlFor="tPremiNonHRV">T. Premi Non HRV</label>
                                                        <input type="text" id="tPremiNonHRV" className="form form-control" value={tPremiNonHRV} onFocus={() => {if (tPremiNonHRV === 0) {setTPremiNonHRV(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setTPremiNonHRV(input); }}onBlur={() => {if (tPremiNonHRV === "") {setTPremiNonHRV(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-md-2 mb-3">
                                                        <label htmlFor="tPremiJabatan">T. Premi Jabatan</label>
                                                        <input type="text" id="tPremiJabatan" className="form form-control" value={tPremiJabatan} onFocus={() => {if (tPremiJabatan === 0) {setTPremiJabatan(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setTPremiJabatan(input); }}onBlur={() => {if (tPremiJabatan === "") {setTPremiJabatan(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-md-2 mb-3">
                                                        <label htmlFor="tPremiBorongan">T. Premi Borongan</label>
                                                        <input type="text" id="tPremiBorongan" className="form form-control" value={tPremiBorongan} onFocus={() => {if (tPremiBorongan === 0) {setTPremiBorongan(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setTPremiBorongan(input); }}onBlur={() => {if (tPremiBorongan === "") {setTPremiBorongan(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-md-2 mb-3">
                                                        <label htmlFor="tPremiKontan">T. Premi Kontan</label>
                                                        <input type="text" id="tPremiKontan" className="form form-control" value={tPremiKontan} onFocus={() => {if (tPremiKontan === 0) {setTPremiKontan(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setTPremiKontan(input); }}onBlur={() => {if (tPremiKontan === "") {setTPremiKontan(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-md-2 mb-3">
                                                        <label htmlFor="tPremiLainnya">T. Premi Lainnya</label>
                                                        <input type="text" id="tPremiLainnya" className="form form-control" value={tPremiLainnya} onFocus={() => {if (tPremiLainnya === 0) {setTPremiLainnya(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setTPremiLainnya(input); }}onBlur={() => {if (tPremiLainnya === "") {setTPremiLainnya(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-md-2 mb-3">
                                                        <label htmlFor="tCatuBeras">T. Catu Beras</label>
                                                        <input type="text" id="tCatuBeras" className="form form-control" value={tCatuBeras} onFocus={() => {if (tCatuBeras === 0) {setTCatuBeras(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setTCatuBeras(input); }}onBlur={() => {if (tCatuBeras === "") {setTCatuBeras(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="thr">THR</label>
                                                        <input type="text" id="thr" className="form form-control" value={thr} onFocus={() => {if (thr === 0) {setThr(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setThr(input); }}onBlur={() => {if (thr === "") {setThr(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="bonus">Bonus</label>
                                                        <input type="text" id="bonus" className="form form-control" value={bonus} onFocus={() => {if (bonus === 0) {setBonus(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setBonus(input); }}onBlur={() => {if (bonus === "") {setBonus(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="lembur">Lembur</label>
                                                        <input type="text" id="lembur" className="form form-control" value={lembur} onFocus={() => {if (lembur === 0) {setLembur(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setLembur(input); }}onBlur={() => {if (lembur === "") {setLembur(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="tPph">T. PPH</label>
                                                        <input type="text" id="tPph" className="form form-control" value={tPph} onFocus={() => {if (tPph === 0) {setTPph(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setTPph(input); }}onBlur={() => {if (tPph === "") {setTPph(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="rapelGaji">Rapel Gaji</label>
                                                        <input type="text" id="rapelGaji" className="form form-control" value={rapelGaji} onFocus={() => {if (rapelGaji === 0) {setRapelGaji(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setRapelGaji(input); }}onBlur={() => {if (rapelGaji === "") {setRapelGaji(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="lainnya">Lainnya</label>
                                                        <input type="text" id="lainnya" className="form form-control" value={lainnya} onFocus={() => {if (lainnya === 0) {setLainnya(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setLainnya(input); }}onBlur={() => {if (lainnya === "") {setLainnya(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                </div>
                                                <p className="text-center mt-3 fw-bold">-- Data Gaji Potongan --</p>
                                                <div className="row px-4 pt-3" style={{backgroundColor:"rgb(252, 253, 255)",borderRadius:"10px"}}>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="iBKesehatan">Iuran BPJS Kes.</label>
                                                        <input type="text" id="iBKesehatan" className="form form-control" value={iBKesehatan} onFocus={() => {if (iBKesehatan === 0) {setIBKesehatan(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setIBKesehatan(input); }}onBlur={() => {if (iBKesehatan === "") {setIBKesehatan(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="iBPensiun">Iuran BPJS Pensiun</label>
                                                        <input type="text" id="iBPensiun" className="form form-control" value={iBPensiun} onFocus={() => {if (iBPensiun === 0) {setIBPensiun(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setIBPensiun(input); }}onBlur={() => {if (iBPensiun === "") {setIBPensiun(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="iBJht">Iuran BPJS JHT</label>
                                                        <input type="text" id="iBJht" className="form form-control" value={iBJht} onFocus={() => {if (iBJht === 0) {setIBJht(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setIBJht(input); }}onBlur={() => {if (iBJht === "") {setIBJht(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="pBKesehatan">Pot. BPJS Kesehatan</label>
                                                        <input type="text" id="pBKesehatan" className="form form-control" value={pBkesehatan} onFocus={() => {if (pBkesehatan === 0) {setPBkesehatan(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setPBkesehatan(input); }}onBlur={() => {if (pBkesehatan === "") {setPBkesehatan(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="pBPensiun">Pot. BPJS Pensiun</label>
                                                        <input type="text" id="pBPensiun" className="form form-control" value={pBPensiun} onFocus={() => {if (pBPensiun === 0) {setPBPensiun(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setPBPensiun(input); }}onBlur={() => {if (pBPensiun === "") {setPBPensiun(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="pBJkm">Pot. BPJS JKM</label>
                                                        <input type="text" id="pBJkm" className="form form-control" value={pBJkm} onFocus={() => {if (pBJkm === 0) {setPBJkm(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setPBJkm(input); }}onBlur={() => {if (pBJkm === "") {setPBJkm(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="pBJkk">Pot. BPJS JKK</label>
                                                        <input type="text" id="pBJkk" className="form form-control" value={pBJkk} onFocus={() => {if (pBJkk === 0) {setPBJkk(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setPBJkk(input); }}onBlur={() => {if (pBJkk === "") {setPBJkk(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="pBJht">Pot. BPJS JHT</label>
                                                        <input type="text" id="pBJht" className="form form-control" value={pBJht} onFocus={() => {if (pBJht === 0) {setPBJht(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setPBJht(input); }}onBlur={() => {if (pBJht === "") {setPBJht(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-md-2 mb-3">
                                                        <label htmlFor="pKontanan">Pot. Kontanan</label>
                                                        <input type="text" id="pKontanan" className="form form-control" value={pKontanan} onFocus={() => {if (pKontanan === 0) {setPKontanan(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setPKontanan(input); }}onBlur={() => {if (pKontanan === "") {setPKontanan(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-md-2 mb-3">
                                                        <label htmlFor="pTotal">Pot. Total</label>
                                                        <input type="text" id="pTotal" className="form form-control" value={pTotal} onFocus={() => {if (pTotal === 0) {setPTotal(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setPTotal(input); }}onBlur={() => {if (pTotal === "") {setPTotal(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                    <div className="col-12 col-sm-4 col-lg-2 mb-3">
                                                        <label htmlFor="pLainnya">Pot. Lainnya</label>
                                                        <input type="text" id="pLainnya" className="form form-control" value={pLainnya} onFocus={() => {if (pLainnya === 0) {setPLainnya(""); }}} onChange={(e) => {const input = e.target.value.replace(/\D/g, "");setPLainnya(input); }}onBlur={() => {if (pLainnya === "") {setPLainnya(0); }}} style={{fontSize:"11pt"}}/>
                                                    </div>
                                                </div>
                                                <input type="text" className="form-disable" value={id} readOnly required/>
                                                <input type="text" className="form-disable" value={perusahaan} readOnly required/>
                                                <input type="text" className="form-disable" value={bulan} readOnly required/>
                                                <input type="text" className="form-disable" value={tahun} readOnly required/>
                                                <input type="submit" className="btn btn-webew-login mb-3 mt-4" value="Ubah Data"/>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MenuUbahKaryawanTidakTetap